/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { Image } from "semantic-ui-react";
import { ActionsTable } from "ceco-window-table";
import { CategoryDeleteModal } from "../../modals/CategoryDeleteModal";
import { CategoryModal } from "../../modals/CategoryModal";
import { MoreHorizontal, Edit, Delete } from "ceicons";
import DropDownButton from "../../DropDownButton";

export default function CategoriesTable(props) {
  const { categoriesParsed, _refetch, totalCount, handleScroll } = props;
  const t = useTranslation();

  const columnsTable = [
    {
      key: "picture",
      basis: 1,
      width: 150,
      ItemRenderer: PictureCell,
    },
    {
      key: "name",
      basis: 1,
      title: t("table-header.name"),
    },
    {
      key: "id",
      basis: 1,
      ItemRenderer: <EditCell refetchData={_refetch} />,
      width: 150,
    },
  ];

  return (
    <ActionsTable
      legend={<strong>pedidos en total o algo asi</strong>}
      actions={[]}
      allowItemSelection={false}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      gridActions={[
        <div className="right floated" key="right-side">
          <strong>
            {totalCount} {t("count.categories")}
          </strong>
        </div>,
      ]}
      items={categoriesParsed}
      columns={columnsTable}
      onScrollTable={handleScroll}
    />
  );
}

const EditCell = (props) => {
  const { data, rowIndex, columnIndex, style, refetchData } = props;
  const { items } = data;
  const id = items[rowIndex][columnIndex];
  const name = items[rowIndex][columnIndex - 1];
  const picture = items[rowIndex][0];

  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="edit cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <CategoryModal
          category={{ id, name, picture }}
          edit
          refetchData={refetchData}
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />

        <CategoryDeleteModal
          categoryName={name}
          categoryId={id}
          refetchData={refetchData}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
        />
      </DropDownButton>
    </div>
  );
};
const PictureCell = (props) => {
  const { data, rowIndex, columnIndex, style } = props;
  const { items } = data;

  const icon = items[rowIndex][columnIndex];
  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        padding: "1em",
        border: "",
      }}
      className="cell"
    >
      <Image src={icon} avatar />
    </div>
  );
};
